(function () {
  var sections = document.querySelectorAll('[data-course-features]');
  if (!sections.length) return;

  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (section) {
      section.setAttribute('data-visible', '');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-visible', '');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });
})();
